import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { SEOHelmet } from '../../hooks/useSEO';

import { FaAngleDoubleRight } from "react-icons/fa";
import rabbit from "../../assets/blogpages/2x/Asset 84@2x.png";
import buffalo from "../../assets/blogpages/2x/blog 8 set 24 img2.png";
import Rabbitu from "../../assets/blogpages/2x/Set 34 Blog 21 Img2.png";
import Eliphiphi from "../../assets/blogpages/2x/Set 34 Blog 21 Img1.png";
import turtle from "../../assets/blogpages/2x/blog 8 set 24 img1.png";
import Liona_Sheepu from "../../assets/blogpages/2x/Set 47 Blog 15 Img1.png";
import activity1 from "../../assets/blogpages/2x/Set 34 Blog 21 AC1.png";
import activity2 from "../../assets/blogpages/2x/Set 34 Blog 21 AC2.png";
import finalElephant from "../../assets/blogpages/2x/Asset 71@2x.png";
import safiaElephant from "../../assets/blogpages/2x/Asset 73@2x.png";
import { Link, useParams, useNavigate } from "react-router-dom";

import TheChallenge from "../../assets/blogpages/2x/Asset 97@2x.png";
import Whattodo from "../../assets/blogpages/2x/Asset 95@2x.png";
import Whatnottodo from "../../assets/blogpages/2x/Asset 93@2x.png";
import activitycard from "../../assets/blogpages/2x/Asset 94@2x.png";
import whatchlearn from "../../assets/blogpages/2x/Asset 96@2x.png";
import board from "../../assets/blogpages/2x/Asset 90@2x.png";

import weeklyActivity2 from "../../assets/blogpages/2x/Asset 39@2x.png";

import Linkdin from "../../assets/blogpages/2x/Asset 70@2x.png";
import youtube from "../../assets/blogpages/2x/Asset 80@2x.png";
import facebook from "../../assets/blogpages/2x/Asset 81@2x.png";
import instaIcon from "../../assets/blogpages/2x/Asset 69@2x.png";
import Pinterest from "../../assets/blogpages/2x/Asset 83@2x.png";
import share from "../../assets/blogpages/2x/Asset 78@2x.png";
import thumbnail from "../../assets/blogs/2x/Set 34 Blog 21 Thumbnail.png";
import bell from "../../assets/blogpages/2x/Asset 75@2x.png";
import weeklyActivity from "../../assets/blogpages/2x/Asset 74@2x.png";
import kidsStory from "../../assets/blogpages/Story/Set 34 Blog 21 KidzStory.png";
// import kidsSong from "../../assets/blogpages/Jingle/set 01.png";
import kidsSong from "../../assets/blogpages/Jingle/Set 34 Blog 21 KidzSong.png";
import kidslearning from "../../assets/blogpages/Interactive/Set 34 Blog 21 KidzLearning.png";



import boardimg from "../../assets/blogs/2x/Asset 25@2x.png";
import elephantImg from "../../assets/blogs/2x/Asset 22@2x.png";
import cowImg from "../../assets/blogs/2x/Asset 31@2x.png";
import lionImg from "../../assets/blogs/2x/Asset 29@2x.png";
import deerImg from "../../assets/blogs/2x/Asset 30@2x.png";
import turtleImg from "../../assets/blogs/2x/Asset 28@2x.png";
import elephiImg from "../../assets/blogs/2x/Asset 32@2x.png";
import geassdivImg from "../../assets/blogs/2x/Asset 23@2x.png";
import blog1Img from "../../assets/blogs/2x/Asset 24@2x.png";
import styles from "./JungleMoralsUI.module.css"
import thumbnail1 from "../../assets/blogs/2x/Blog 20 Set 5 Thumbnail.png";
import thumbnail2 from "../../assets/blogs/2x/Blog 16 Set 31 thumbanil.png";
import thumbnail3 from "../../assets/blogs/2x/Set 42 Blog 14 thumbnail.png";
import { Helmet } from "react-helmet-async";




const Helpingkidsbuildhealthyhabitsanddailyroutines = () => {

    const params = useParams();
    const slug = params.slug || "helping-kids-learn-why-spreading-rumours-hurts-friendships";
    const navigate = useNavigate();

    // ✅ Blog data ko slug se match karo (optional - agar dynamic content chahiye)
    const blogData = {
        "Helping-kids-build-healthy-habits-and-daily-routines": {
            title: "Helping Kids Build Healthy Habits and Daily Routines",
            date: "07 January 2026",
            readTime: "4 min read"
        },
    };

    const currentBlog = blogData[slug] || {
        title: "Blog Not Found",
        date: "",
        readTime: ""
    };
 
     const handleBlogClick = (slug) => {
    navigate(`/blog/${slug}`);
  };



    const blogPost = [
        {
            id: 1,
            title: "Kids Story",
            animal: "elephant",
            animalImg: elephantImg,
            image: kidsStory,
            youtubeLink: "https://www.youtube.com/watch?v=3ieEeNEEYFk" // Apna link yahan daalo
        },
        {
            id: 2,
            title: "Kids Song",
            animal: "cow",
            animalImg: cowImg,
            image: kidsSong,
            youtubeLink: "https://www.youtube.com/watch?v=TVzu6hx7Kcs"
        },
        {
            id: 3,
            title: "Kids Learning",
            animal: "lion",
            animalImg: lionImg,
            image: kidslearning,
            youtubeLink: "https://www.youtube.com/watch?v=C9p_1gUPhGU"
        },
    ];


    const blogPosts = [

        {
            id: 1,
            title: "Helping Kids Learn to Follow Rules...",
            description: "Simple conversations, everyday situations, and a kids moral story that help children understand greed, respect...",
            date: "4 May 2026",
            readTime: "6 min read",
            animal: "deer", // brown deer
            animalImg: deerImg, // Yahan image add karein
            image: thumbnail1,
               slug: "helping-kids-build-healthy-habits-and-daily-routines",
               alt:"Cartoon animals teaching forgiveness, friendship, and values.",
        },
        {
            id: 2,
            title: "Helping Kids Believe in Themselves...",
            description: "Simple conversations, everyday situations, and a kids moral story that help children recognise greed, value friendsh...",
            date: "5 April 2026",
            readTime: "4 min read",
            animal: "turtle", // green turtle
            animalImg: turtleImg, // Yahan image add karein
            image: thumbnail2,
               slug: "helping-kids-believe-in-themselves-and-trust-that-things-workout",
                alt:"Cartoon lion with a bow and arrow promoting trust the journey, staying safe, and self-love.",
        },
        {
            id: 3,
            title: "Helping Kids Understand That People...",
            description: "Simple conversations, everyday situations, and a kids moral story that help children recognise greed, value friendsh...",
            date: "21 March 2026",
            readTime: "4 min read",
            animal: "elephant2", // gray elephant
            animalImg: elephiImg, // Yahan image add karein
            image: thumbnail3,
               slug: "helping-kids-understand-that-people-matter-more-than-things",
               alt:"Cartoon animals teaching forgiveness, friendship, and values.",
        }
    ];

    const animalStyles = {
        elephant: { top: '-50px', left: '-80px', transform: 'scale(0.8)' },
        cow: { top: '-75px', left: '50%', transform: 'translateX(-50%) scale(0.7)' },
        lion: { top: '-80px', right: '-60px', transform: 'scale(0.8)' },
        deer: { top: '-85px', left: '-85px', transform: 'scale(0.75)' },
        turtle: { top: '-80px', left: '50%', transform: 'translateX(-50%) scale(0.7)' },
        elephant2: { top: '-70px', right: '-80px', transform: 'scale(0.8)' }
    };

    //share blogs function
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: document.title,
                    // text: 'Is blog ko dekho ',
                    url: window.location.href,
                });
            } catch (err) {
                // user ne cancel kiya to kuch mat karo
            }
        } else {
            alert('Share supported nahi hai is browser me');
        }
    };



    const socialLinks = [
        { img: Linkdin, link: "https://www.linkedin.com/company/jungle-morals-entertainment/?viewAsMember=true" },
        { img: youtube, link: "https://www.youtube.com/channel/UCF4P0048BiT04m1ss61qpGA" },
        { img: facebook, link: "https://www.facebook.com/junglemorals/" },
        { img: instaIcon, link: "https://www.instagram.com/junglemorals/" },
        { img: Pinterest, link: "https://in.pinterest.com/junglemorals/" },
        { img: share, isShare: true },
    ];

    const TopCard = ({ title, img, onClick }) => (
        <div className="col-4 col-sm-4 col-md-4 col-lg">
            <div
                onClick={onClick}
                className="position-relative overflow-hidden"
                style={{ cursor: "pointer" }}
            >
                {/* Background image */}
                <img src={img} alt={title} className="img-fluid w-100" />

                {/* Overlay text */}
                <div
                    className={`position-absolute top-50 start-50 translate-middle fw-bold ${styles.usereff}`}

                >
                    {title}
                </div>
            </div>
        </div>
    );


    const challengeRef = useRef(null);
    const whatToDoRef = useRef(null);
    const whatNotRef = useRef(null);
    const activityRef = useRef(null);
    const watchRef = useRef(null);
    const newsletterRef = useRef(null);


    const scrollTo = (ref) => {
        ref.current.scrollIntoView({ behavior: "smooth" });
    };

    //for the margintop fix of page
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 585);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 585);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    //SEO meta information


    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    // useEffect(() => {
    //     // Fetch blogs from localStorage (same as admin dashboard)
    //     const blogs = JSON.parse(localStorage.getItem("adminBlogs"));

    //     if (blogs) {
    //         const currentBlog = blogs.find(b => b.slug === slug);
    //         setBlog(currentBlog);
    //     }

    //     setLoading(false);
    // }, [slug]);

    // if (loading) {
    //     return <div className="container py-5 text-center">Loading...</div>;
    // }

    // if (!blog) {
    //     return (
    //         <div className="container py-5">
    //             <div className="alert alert-danger">
    //                 <h4>Blog not found</h4>
    //                 <p>Sorry, the blog post you're looking for doesn't exist.</p>
    //             </div>
    //         </div>
    //     );
    // }


    return (

        <>
       <Helmet>
  <title>
    Helping Kids Build Healthy Habits and Daily Routines | Jungle Morals
  </title>

  <meta
    name="description"
    content="Discover gentle ways to teach children aged 3–7 hygiene, healthy habits, and daily routines. Explore tips, activity cards, and kids' moral stories from Jungle Morals that make healthy living fun and meaningful."
  />

  <meta
    name="robots"
    content="index, follow"
  />

  <link
    rel="canonical"
    href="https://www.junglemorals.com/blog/helping-kids-build-healthy-habits-and-daily-routines"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Helping Kids Build Healthy Habits and Daily Routines | Jungle Morals"
  />

  <meta
    property="og:description"
    content="Discover gentle ways to teach children aged 3–7 hygiene, healthy habits, and daily routines with fun parenting tips, activity cards, and moral stories from Jungle Morals."
  />

  <meta
    property="og:url"
    content="https://www.junglemorals.com/blog/helping-kids-build-healthy-habits-and-daily-routines"
  />

  <meta
    property="og:type"
    content="article"
  />

  <meta
    property="og:image"
    content="https://www.junglemorals.com/static/media/Set%2047%20Blog%2015%20Thumbnail.532a1a9053ed24302a70.png"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Helping Kids Build Healthy Habits and Daily Routines | Jungle Morals"
  />

  <meta
    name="twitter:description"
    content="Discover gentle ways to teach children aged 3–7 hygiene, healthy habits, and daily routines with fun parenting tips, activity cards, and moral stories from Jungle Morals."
  />

  <meta
    name="twitter:image"
    content="https://www.junglemorals.com/static/media/Set%2047%20Blog%2015%20Thumbnail.532a1a9053ed24302a70.png"
  />

  {/* Schema */}
</Helmet>

            <div className="" style={{
                color: '#005d52',
                marginTop: isMobile ? '-62vh' : '-45vh',
                minHeight: '100vh',
                position: 'relative',
                overflow: 'hidden',

            }}>
                <div className="container py-3 py-md-2 col-md-10 text-start" style={{ maxWidth: '1300px' }}
                >

                    {/* Breadcrumb Path */}
                    <div className={`path fs-4 ${styles.Breadcrumb} p-2 m-0 ps-0 mb-3 mb-md-2 d-flex flex-wrap align-items-center gap-2 font-brandon z-2`}>
                        <Link to={'/'} className="text-decoration-none text-reset pe-auto z-1">
                            <span className="path-element text-pr-black ff-roboto pe-auto">Home</span>
                        </Link>
                        <FaAngleDoubleRight className="fa-icons" style={{ fontSize: '12px' }} />
                        <Link to={'/blogs'} className="text-decoration-none text-reset z-1">
                            <span className="path-element text-pr-black ff-roboto">Blogs</span>
                        </Link>
                        <FaAngleDoubleRight className="fa-icons" style={{ fontSize: '12px' }} />
                        <span className="path-element">Helping Kids Build Healthy Habits and Daily Routines</span>
                    </div>
                    {/* Main Heading */}
                    <h1 className={`font-brandon-black  display-1 fw-bold ${styles.mainh1} `} >
                        Helping Kids Build Healthy Habits and Daily Routines
                    </h1>

                    {/* Subheading */}
                    <p className={`font-brandon-thin-italic ${styles.tagline} lh-sm fst-italic`}>
                        Simple conversations, everyday practices, and a kids moral story that help children understand hygiene, build good habits, and follow routines that support a healthy life.
                    </p>

                    {/* Social Links & Date Section */}
                    <div className="path m-0 ps-0  mb-md-2 d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 gap-sm-2">

                        {/* Social Icons */}
                        <div className="path-element text-muted ff-roboto d-flex align-items-center gap-3 order-2 order-sm-1">
                            {socialLinks.map((item, index) => (
                                <a
                                    key={index}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-inline-block"
                                >
                                    <img
                                        src={item.img}
                                        alt="social-icon"
                                        width="40"
                                        height="40"
                                        className="social-icon"
                                        style={{ objectFit: "contain", cursor: "pointer" }}
                                        onClick={() => {
                                            if (item.isShare) {
                                                handleShare();        // ✅ native share
                                            } else {
                                                window.open(item.link, '_blank'); // ✅ normal social links
                                            }
                                        }}

                                    />
                                </a>
                            ))}
                        </div>

                        {/* Date & Read Time */}
                        <div className="d-flex flex-row flex-sm-column align-items-start align-items-sm-end gap-2 gap-sm-1 order-1 order-sm-2 font-brandon">
                            <small className={`text-nowrap ${styles.date}`} style={{ color: '#005d52', fontSize: '20px', fontWeight: "900" }}>
                                11 May 2026
                            </small>
                            <span className="d-inline d-sm-none text-muted">•</span>
                            <small className={`text-nowrap ${styles.date}`} style={{ color: '#005d52', fontSize: '20px', fontWeight: "900" }}>
                                4 min read
                            </small>
                        </div>
                    </div>
                </div>



                <div className="container-fluid mb-2 px-3 px-md-4" style={{ maxWidth: '1600px' }}
                >
                    <div className="row justify-content-center">
                        <div className="col-12 col-xl-10">
                            <div className={`row text-center g-2 g-md-3 font-brandon-bold  ${styles.strongtext}`}>
                                <TopCard title="The Challenge" img={TheChallenge} onClick={() => scrollTo(challengeRef)} />
                                <TopCard title="What To Do" img={Whattodo} onClick={() => scrollTo(whatToDoRef)} />
                                <TopCard title="What NOT To Do" img={Whatnottodo} onClick={() => scrollTo(whatNotRef)} />
                                <TopCard title="Activity Card" img={activitycard} onClick={() => scrollTo(activityRef)} />
                                <TopCard title="Watch and Learn" img={whatchlearn} onClick={() => scrollTo(watchRef)} />
                            </div>
                        </div>
                    </div>
                </div>


                <section ref={challengeRef} className="container  col-md-10" style={{ maxWidth: '1300px' }}
                >
                    <div className="d-flex justify-content-center align-items-center flex-column">


                        <div
                            className="text-center board-wrapper"
                            style={{
                                backgroundImage: `url(${boardimg})`,
                                backgroundSize: 'contain',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                aspectRatio: '16 / 10',     // ⭐ key fix
                            }}
                        >
                            <img
                                src={thumbnail}
                                alt="Cute cartoon monkey in a jungle with healthy habits icons and text about routines and caring for the body."
                                style={{
                                    width: '93%',
                                    height: '90%',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>

                        <div className="">
                            <h2 className={`font-brandon-black mt-2 mt-md-0 ${styles.strongtextheading} `}>Introduction</h2>
                            <p className={`font-brandon ${styles.introtext} lh-sm mb-5`}>Between ages<strong className={styles.strongtext}> 3-7</strong>, children are forming habits that can last a lifetime. Daily actions like washing hands, brushing teeth, eating on time, and sleeping well slowly shape how children feel and function.</p>

                            <p className={`font-brandon ${styles.introtext} lh-sm mb-5`}>Parents often look for gentle ways to teach <strong className={styles.strongtext}>hygiene, good habits</strong>, and <strong className={styles.strongtext}>healthy routines</strong> without constant reminders. When children understand that taking care of their body helps them feel strong and happy, routines begin to feel meaningful rather than forced.</p>


                            <p className={`font-brandon ${styles.introtext} lh-sm`}>This week at Jungle Morals, we explore how children can learn the importance of hygiene, practise good habits, and follow routines that support health and confidence.</p>
                        </div>

                    </div>
                </section>


                <section ref={challengeRef} className={`container py-0 py-md-4 col-md-10 mt-3 ${styles.TheChallenge}`} style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black   ${styles.strongtextheading}`} >The Challenge</h2>
                    {/* <p className={`font-brandon ${styles.fs2} ${styles.TheChallengeh2} lh-sm mb-4 mb-md-5 fst-italic`}>Why children repeat things without thinking</p> */}
                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm mb-4 mb-md-5`}>Why children resist hygiene and routinesYoung children are still learning consistency and body awareness. Daily habits like washing hands, brushing teeth, or following routines can feel boring or unnecessary to them. Without understanding the purpose behind these actions, children may resist or forget healthy routines.</p>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-6">


                            <h3 className={`font-brandon-black  ${styles.strongtext2} `}>Parents may notice children:</h3>
                            <ul className={`font-brandon ${styles.ul21} lh-sm  ps-4.5 mb-md-5`}>
                                <li>Forgetting to wash hands</li>
                                <li>Resisting brushing teeth</li>
                                <li>Avoiding bath time</li>
                                <li>Skipping routines</li>
                                <li>Wanting to rush through daily habits</li>
                            </ul>

                            <h3 className={`font-brandon-black  ${styles.strongtext2} `}>You may hear children say:</h3>
                            <ul className={`font-brandon ${styles.ul21} lh-sm  ps-4.5 mb-5`} >
                             <li>“I already washed.”</li>
                                <li>“I do not want to.”</li>
                                <li>“It takes too long.”</li>
                                <li>“I will do it later.”</li>
                                {/* <li>“Can you do it for me?”</li> */}
                            </ul>
                        </div>

                        <div className="col-md-6 text-center">
                            <img src={Eliphiphi} className={`${styles.Liona} img-fluid`} alt="Cute blue cartoon elephant with a flower crown, sitting with a soup bowl and TV remote surrounded by flowers." width={"380"} />
                        </div>
                        <p className={`font-brandon ${styles.introtext}  lh-sm mb-5`}>These behaviours are common. Children between ages <strong className={styles.strongtext}> 3-7</strong> are still learning consistency, body awareness, and why routines matter.</p>

                          {/* <p className={`font-brandon ${styles.introtext}  lh-sm mb-5`}>Small image on the right: a Jungle Morals character thinking before choosing between two options.</p> */}


                    </div>
                </section>



                <section ref={whatToDoRef} className="container mb-5 col-md-10 py-1" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black mt-2 mb-3 ${styles.strongtextheading}`}>What To Do</h2>
                    <p className={`font-brandon ${styles.TheChallengeh2} fs-3 lh-sm fst-italic`}>Gentle ways to help kids build healthy habits and routines:</p>
                    <div className="row align-items-center justify-content-center">
                        <div className={`col-md-6 ${styles.WTD}`}>

                            <h3 className={`font-brandon-bold mt-3 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Explain the purpose of hygiene</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Help children understand why habits matter. “Washing hands keeps our body healthy.”</li>
                                {/* <li>“When you clean up now, we have more time to play later.”</li> */}
                            </ul>

                            <h3 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Make routines predictable</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Doing things in the same order helps children remember. “First we brush, then we read.”</li>
                                {/* <li>“Let us start with just one toy.”</li> */}
                            </ul>

                            <h3 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Turn habits into shared moments</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Doing things together makes them easier. “Let us brush our teeth together.”</li>
                                {/* <li>You kept going even when it felt hard.”</li> */}
                            </ul>

                            <h3 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Use reminders without pressure</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li className={`${styles.li_WTDp4}`}>Gentle cues work better than commands. “What comes next in our routine?”</li>
                                {/* <li>“You fixed the problem by finishing it.”</li> */}
                            </ul>

                            <h3 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Praise consistency</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>“You followed your routine today. That was responsible.”</li>
                            </ul>

                        </div>
                        <div className="col-md-6 text-center">
                            <img src={Rabbitu} className={`${styles.imgfluid1} img-fluid`} alt="Sad cartoon rabbit sitting on a wooden chair wearing a blue shirt and pink shorts." width={"400"} />
                        </div>
                    </div>
                </section>


                <section ref={whatNotRef} className="container col-md-10 py-1 mt-3" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black mb-2 ${styles.strongtextheading}`}>What NOT To Do</h2>
                    <p className={`font-brandon ${styles.fs2} ${styles.TheChallengeh2} lh-sm mb-4 fst-italic`}>When teaching hygiene and routines, avoid these habits.</p>
                    <div className=" col-md-12">
                        <h3 className={`font-brandon-bold ${styles.fs2} ${styles.strongtext} `}>Avoid:</h3>
                        <ul className={`font-brandon ${styles.fs2} ${styles.avoidtext} lh-sm  list-unstyled ps-0`}>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not rush or threaten</li>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not shame forgotten habits</li>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not change routines often</li>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                	Do not expect perfection</li>
                            <li>

                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                	Do not turn routines into punishment</li>

                        </ul>

                        
                        <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2}  lh-sm mt-4 mt-md-5`}>Healthy habits grow through patience and repetition.</p>
                        <p className={`font-brandon ${styles.fs2} ${styles.belltext} lh-sm mt-4 mt-md-5`}>
                                                                                     <img
                                                                          src={bell}
                                                                          alt="Yellow notification bell icon flat design"
                                                                          width="50px"
                                                                          className="mb-2 me-3"
                                                                        />
                                                                                      Want weekly Jungle activities, updates, and more?{" "}
                                                                                      <Link
                                                                                        to="#"
                                                                                        onClick={(e) => {
                                                                                          e.preventDefault();
                                                                        
                                                                                          if (newsletterRef.current) {
                                                                                            newsletterRef.current.scrollIntoView({
                                                                                              behavior: "smooth",
                                                                                              block: "center",
                                                                                            });
                                                                                          }
                                                                                        }}
                                                                                      >
                                                                                        {" "}
                                                                                        Join Our Newsletter!
                                                                                      </Link>
                                                                                    </p>
                    </div>
                </section>


                <section ref={activityRef} className="container py-1 col-md-10" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black  ${styles.strongtextheading}`}>‘Bedtime Wind-Down’ Activity Card:</h2>
                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm fst-italic`}>A Fun Way to Teach Kids Hygiene and Daily Routines</p>

                    <div className="row my-4">
                        <div className="col-md-6">
                            <img src={activity1} alt="Jungle Morals activity card for parents about bedtime wind-down with cartoon elephant and lion characters." className="img-fluid " />
                        </div>
                        <div className="col-md-6">
                            <img src={activity2} alt="Activity card with bedtime routine tips for kids, including dinner, brushing teeth, story time, and lights out." className="img-fluid " />
                        </div>
                    </div>
                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm fst-italic`} >Why this activity works:
                       This activity helps children understand how daily habits support health. It turns routines into conscious choices instead of chores.</p>
                </section>

                <section ref={watchRef} className="container col-md-10 py-1 mt-3" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-bold ${styles.strongtext}`}>How parents should guide it</h2>
                    <ul className={`font-brandon ${styles.fs2} lh-sm ${styles.activityULLI}  ps-0.5`}>
                        <li>Do the activity together</li>
                        <li>Talk about why each habit matters</li>
                        <li>Encourage consistency with kindness</li>
                    </ul>


                    <h2 className={`font-brandon-bold ${styles.strongtext}`}>What children learn:</h2>
                    <ul className={`font-brandon ${styles.fs2} lh-sm ${styles.activityULLI}  ps-0.5`}>
                        <li>Hygiene awareness</li>
                        <li>Healthy habits</li>
                        <li>Responsibility</li>
                        <li>Routine building</li>
                    </ul>


                    <div>

                        <div className="position-relative d-flex justify-content-center align-items-center my-4">
                                                                                      <Link
                                                                                        to={"/form"}
                                                                                        className="position-relative d-flex justify-content-center align-items-center my-4 text-reset"
                                                                                      >
                                                                                        <h3 className={`position-absolute ${styles.fs22} grab-text text-center font-adventuring`}>
                                                                                          Grab your free activity card
                                                                                        </h3>
                                                                        
                                                                                        {/* Board image */}
                                                                                        <img
                                                                                          src={board}
                                                                                          alt="Colorful festive marquee light frame with glowing multicolor bulbs and blank banner space"
                                                                                          className="img-fluid board-img"
                                                                                          width={"800px"}
                                                                                        />
                                                                                      </Link>
                                                                                    </div>


                        <h2 className={`font-brandon-bold   ${styles.strongtextheading}`}>Watch This Week’s - I Am Healthy I Am Wealthy</h2>
                        {/* Header Section */}
                        {/* Blog Cards Grid */}
                      <div className={`row ${styles.Links} g-2 g-md-5`}>
                            {blogPost.map((post, index) => (
                                <div key={post.id} className="col-12 col-md-6 col-lg-4">
                                    <div
                                        className="card h-100"
                                        style={{
                                            border: 'none',
                                            cursor: 'pointer',
                                            transition: 'transform 0.3s ease'
                                        }}
                                        onClick={() => window.open(post.youtubeLink, '_blank')}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        {/* Card Image/Content Area */}
                                        <div style={{
                                            height: '240px',
                                            backgroundImage: `url(${boardimg})`,
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 10px'
                                        }}>
                                            <img
                                                src={post.image}
                                                alt={post.title}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </div>

                                        {/* Grass decoration */}
                                        <div style={{
                                            width: "50%",
                                            minHeight: "150px",
                                            height: "30vw",
                                            maxHeight: "100px",
                                            marginTop: "24%",
                                            position: 'absolute',
                                            marginLeft: "61%",
                                        }}>
                                            <img
                                                src={geassdivImg}
                                                alt="grass decoration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </div>

                                        <div className="card-body" style={{ padding: '1px' }}>
                                            <h5 className="card-title font-brandon-bold fs-3 lh-sm" style={{
                                                color: '#005d52',
                                                fontWeight: 'bold',
                                                fontSize: '22px',
                                                marginBottom: '10px',
                                                textAlign: "center"
                                            }}>
                                                {post.title}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>

                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm mb-1 mt-4 mt-md-5`}>This animated kids moral story teaches:</p>
                    <ul className={`font-brandon ${styles.fs2} ${styles.activityULLI} lh-sm   ps-0.5`} >
                        <li>Importance of hygiene</li>
                        <li>Building healthy habits</li>
                        <li>Following daily routines</li>
                        <li>Caring for the body</li>
                    </ul>
                    <p className={`font-brandon ${styles.fs2} ${styles.activityULLI} lh-sm mb-4 mt-0 mb-md-5 mt-md-5`}>Kids love watching characters make small choices that lead to big learnings.</p>
                    <p className={`font-brandon ${styles.fs30} lh-sm d-flex gap-3`}>
                                                     <img
                                                       src={bell}
                                                       alt="Yellow notification bell icon flat design"
                                                       srcset=""
                                                       width={"50px"}
                                                       className="mb-2  "
                                                     />
                                                     <Link
                                                       to={"https://www.youtube.com/channel/UCF4P0048BiT04m1ss61qpGA"}
                                                       target="blank"
                                                     >
                                                       Watch more Jungle Morals stories on YouTube!
                                                     </Link>
                                                   </p>

                    <h4 className={`font-brandon-bold  mt-5 ${styles.strongtextheading}`}>Final Thoughts & Learnings</h4>
                    <ul className={`font-brandon ${styles.fs2} ${styles.activityULLI} lh-base   ps-0.5`}>
                        <li>Children learn punctuality through habits, not pressure</li>
                        <li>Time awareness develops slowly between ages three to seven</li>
                        <li>Visual routines help children understand daily time flow</li>
                        <li>Gentle reminders work better than rushing or scolding</li>
                        <li>Preparation reduces morning stress and last-minute delays</li>
                        <li>Praising e ort builds responsibility and self-confidence</li>
                        <li>Play-based activities make time management easier to learn</li>
                        <li>Consistency turns small routines into lifelong punctual habits</li>
                    </ul>

                </section>


                <section className={styles.wisdomSection} style={{ maxWidth: '2900px' }}
                >
                    <div className="container-fluid px-0" style={{ maxWidth: '1600px' }} >
                        <div className="row align-items-center justify-content-start mx-0">
                            <div className={`col-auto text-center ${styles.elephantCol}`}>
                                <img
                                    src={finalElephant}
                                    className={`img-fluid ${styles.elephantImage}`}
                                    alt="elephant"
                                        style={{ marginTop: '-200px' }}   
                                />
                            </div>
                            <div className="col text-start text-white ps-0 ps-sm-3 ps-md-4 ps-lg-2 mb-md-5 ">
                                <h4 className={`font-brandon  mb-1 ${styles.wisdomTitle}`}>Final Jungle Wisdom</h4>
                                <p className={`font-brandon  lh-sm mb-1 ${styles.wisdomText}`}>
                                   Healthy habits practiced daily help children grow strong, confident, and happy.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>




              <section
                        className="container  pt-5 pb-3 pb-md-5 col-md-10 text-start d-flex justify-content-evenly flex-column"
                        style={{ maxWidth: "1300px" }}
                      >
                        <h3 className={`font-brandon-black mt-3 mb-3 ${styles.strongtextheading}`}>
                          Get Weekly Jungle Activities, Updates and More!
                        </h3>
                        <p className={`font-brandon ${styles.fs3} fst-italic lh-sm`}>
                          One simple activty and one gentle parenting tip every week.
                        </p>
              
                         <div
                                    className="d-flex justify-content-center px-2"
                                    ref={newsletterRef}
                                  >
                                    {/* Board Wrapper */}
                                    <div
                                      style={{
                                        position: "relative",
                                        width: "100%",
                                        maxWidth: "700px", //  desktop same, mobile shrink
                                      }}
                                    >
                                      {/* Board Image */}
                                        <img
                                        className={`${styles.mobIMG}`}
                                        src={weeklyActivity2}
                                        alt="Wooden frame border with green leaves decorative nature background blank template"
                                        style={{
                                          width: "100%",
                                          height: "auto",
                                          // display: "none",
                        
                                        }}
                                      />
                                      <img
                                      className={`${styles.desIMG}`}
                                        src={weeklyActivity}
                                        alt="Wooden frame border with green leaves decorative nature background blank template"
                                        style={{
                                          width: "100%",
                                          height: "auto",
                                          // display: "none",
                        
                                        }}
                                      />
                        
                                      {/* CONTENT INSIDE BOARD */}
                                      <div
                                      className={`${styles.mailbox}`}
                                        style={{
                                          position: "absolute",
                                          top: "55%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                          width: "78%",
                                          textAlign: "center",
                                        }}
                                      >
                                        {/* Email Input */}
                                        <input
                                          type="email"
                                          className={`form-control ${styles.inputbox}  mb-2 font-brandon`}
                                          placeholder="Email ID"
                                          style={{
                                            borderRadius: "5px",
                                            border: "2px solid #9ec9bb",
                                            padding: "clamp(12px, 10vw, 6px) 18px",
                                            fontSize: "clamp(22px, 3vw, 5px)",
                                          }}
                                        />
                        
                                        {/* Checkbox */}
                                        <div className={`form-check ${styles.input2} d-flex justify-content-center align-items-center`}>
                                          <input
                                            className={`form-check-input ${styles.checkbox} me-3`}
                                            type="checkbox"
                                            id="weeklyCheck"
                                            style={{
                                              border: "1px solid #2f6f62",
                                              transform: "scale(1.5)",
                                            }}
                                          />
                                          <label
                                            className={`form-check-label ${styles.CTA} font-brandon fs-2 lh-sm`}
                                            htmlFor="weeklyCheck"
                                            style={{
                                              color: "#2f6f62",
                                              fontSize: "clamp(14px, 3vw, 14px)",
                                              marginBottom: "-4px",
                                            }}
                                          >
                                            Send Me Weekly Activities!
                                          </label>
                                        </div>
                        
                                        {/* Small text */}
                                        <p
                                          className={`text-reset font-brandon ${styles.CTA} fs-5 mb-0 mb-md-2 lh-sm`}
                                          style={{
                                            fontSize: "clamp(10px, 1.5vw, 12px)",
                                            marginBottom: "2px",
                                          }}
                                        >
                                          We never spam. Unsubscribe anytime.
                                        </p>
                        
                                        {/* Disclaimer */}
                                        <p
                                          className={`text-reset fs-6 ${styles.CTA} ${styles.lastmailtext} font-brandon`}
                                          style={{
                                            fontSize: "clamp(9px, 2.2vw, 10px)",
                                            lineHeight: "1.3",
                                          }}
                                        >
                                          By sharing your email address, you agree to receive marketing
                                          emails and consent to our{" "}
                                          <span className="text-decoration-underline">
                                            Terms and Conditions
                                          </span>{" "}
                                          and{" "}
                                          <span className="text-decoration-underline">
                                            Privacy Policy
                                          </span>
                                          .
                                        </p>
                                      </div>
                                    </div>
                                  </div>
              
                        {/* <div className="row align-items-center justify-content-center col-md-10">
                          <div className="col-md-4 text-center">
                            <img
                              src={safiaElephant}
                              alt="Cute blue cartoon elephant wearing yellow floral dress with purple garland and flower crown inside green circular frame vector illustration"
                              width="320"
                            />
                          </div>
              
                          <div className="col-md-8 text-start">
                            <h2 className={`mt-3 font-brandon ${styles.fs4}  fw-bold`}>
                              Safia Bano
                            </h2>
                            <p className={`font-brandon ${styles.fs3} lh-sm`}>
                              As the author, I am proud to say that I have been recognized as
                              a New York Times best-selling author. My writing style has
                              captivated audiences, and my stories have received widespread
                              acclaim.
                            </p>
                            <hr
                              className="my-3"
                              style={{
                                height: "2px",
                                backgroundColor: "#005d52",
                                border: "none",
                                opacity: 1,
                              }}
                            />
                            <div className="d-flex justify-content-start gap-3">
                              <Link
                                to={
                                  "https://www.linkedin.com/company/jungle-morals-entertainment/?viewAsMember=true"
                                }
                                target="blank"
                              >
                                <img
                                  src={Linkdin}
                                  alt="LinkedIn logo icon in green circle"
                                  srcset=""
                                  width={"40"}
                                  height={"40"}
                                />
                              </Link>
              
                              <Link
                                to={"https://www.instagram.com/junglemorals/"}
                                target="blank"
                              >
                                <img
                                  src={instaIcon}
                                  alt=""
                                  srcset=""
                                  width={"40"}
                                  height={"40"}
                                />
                              </Link>
                            </div>
                          </div>
                        </div> */}
                      </section>


                <section className="container py-1 col-md-10" style={{ maxWidth: '1300px' }}
                >
                    <h3 className={`mt-3 font-brandon  ${styles.strongtextheading}`}>Similar Picks For You!</h3>
                <div className="mt-4 mt-md-5">
                        {/* Header Section */}
                        {/* Blog Cards Grid */}
                       <div className={`row g-md-5 ${styles.blogRow} mt-5`}>
                            {blogPosts.map((post, index) => (
                                <div key={post.id} className="col-12 col-md-6 col-lg-4">
                                     <div
                         className="card h-100"
                         style={{ cursor: "pointer", border: "none" }}
                         role="button"
                         tabIndex={0}
                         onClick={() => handleBlogClick(post.slug)}
                         onKeyDown={(e) => {
                           if (e.key === "Enter" || e.key === " ") handleBlogClick(post.slug);
                         }}
                       >
                                        {/* Animal Head - Sirf image dikhegi, background nahi */}
                                        <div style={{
                                            position: 'absolute',
                                            ...animalStyles[post.animal],
                                            width: '170px',  // Size badha diya
                                            height: '170px', // Size badha diya
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            zIndex: 10,
                                        }}>
                                            {/* Sirf animal image */}
                                            <img
                                               className={`${styles.animalImg}`}
                                                src={post.animalImg}
                                                alt={post.animal}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain' // contain use karo taaki poora animal dikhe
                                                }}
                                            />
                                        </div>

                                        {/* Card Image/Content Area */}


                                        {/* Card Image/Content Area */}
                                        <div style={{
                                            height: '240px',
                                            backgroundImage: `url(${boardimg})`, // Board frame
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 10px'
                                        }}>
                                            {/* Blog thumbnail image - Board ke andar fit hogi */}
                                            <img
                                                src={post.image}
                                                alt={post.alt}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain', // Image ko board ke andar fit karega
                                                    // borderRadius: '4px'
                                                }}
                                            />
                                        </div>

                                        {/* Grass decoration on top of image */}
                                        <div style={{
                                            width: "50%",
                                            minHeight: "150px",   // mobile
                                            height: "30vw",       // responsive height
                                            maxHeight: "100px",
                                            marginTop: "24%",  // desktop limit
                                            position: 'absolute',
                                            marginLeft: "61%",  // desktop limit

                                        }}>
                                            <img
                                                src={geassdivImg}
                                                alt="grass decoration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: "contain"
                                                }}
                                                onError={(e) => {
                                                    console.log('Grass div image failed:', e);
                                                    console.log('Image path:', geassdivImg);
                                                }}
                                            />
                                        </div>

                                        <div className="card-body" style={{ padding: '1px' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2 font-brandon">
                                                <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>{post.date}</small>
                                                <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>{post.readTime}</small>
                                            </div>
                                            <h5 className="card-title font-brandon" style={{
                                                color: '#005d52',
                                                fontWeight: 'bold',
                                                fontSize: '22px',
                                                marginBottom: '10px'
                                            }}>
                                                {post.title}
                                            </h5>
                                            <p className="card-text font-brandon" style={{
                                                color: '#005d52',
                                                fontSize: '14px',
                                                lineHeight: '1.5',
                                                fontWeight: '400'
                                            }}>
                                                {post.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>
                </section>



            </div>
        </>
    );
};


export default Helpingkidsbuildhealthyhabitsanddailyroutines;



